import axios from "axios";
import { useState } from "react";
import { useMessage } from "../../../../global-components/src";
import { useAuth } from "../../../../global-components/src";
import { UserCheck, UserX } from "react-feather";
import { PACOCA_API_URL } from "../../../../global-components/src/utils/vars";
import { useTranslation } from "react-i18next";

interface PostProps{
    id_user: number;
    is_blocked: boolean;
}

const BlockUser: React.FC<PostProps> = ({ id_user, is_blocked }) => {
    const [isBlocked, setiIsBlocked] = useState(is_blocked ? is_blocked : false );
    const { setMessage } = useMessage();
    const { isAuthenticated, token, user: authUser } = useAuth();
    const { t } = useTranslation();

    const handleBlockUser = async() =>{
        const url = PACOCA_API_URL + "/users/" + (isBlocked ? "unblock/" : "block/") + id_user;
        
        try {
            await axios.post(url, {blocked_user_id: id_user}, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            setiIsBlocked(!isBlocked);
            setMessage(!isBlocked ? t("post.userBlocked") : t("post.userUnblocked"), "success");
        } catch (err: any) {
            console.error(err);
            
            if (err.response) {
                // O servidor respondeu com um código de erro
                console.error("Erro no servidor:", err.response.status, err.response.data);
                setMessage(err.response.data.message || t("generics.error"), "error");
            } else if (err.request) {
                // A requisição foi feita, mas não houve resposta
                console.error("Nenhuma resposta do servidor:", err.request);
                setMessage(t("generics.errors.genericServerError"), "error");
            } else {
                // Outro tipo de erro (ex: erro de configuração)
                console.error("Erro inesperado:", err.message);
                setMessage(t("generics.error"), "error");
            }

            if(err.status == 429 && err.message.blocked)
                setMessage(t("generics.errors.tooManyRequests", { minutes: err.remaining }), "error")

            if(err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "error")

            if(err.status == 401)
                setMessage(t("generics.errors.sessionExpired"), "error")
        }        
    }

    return (
        <>
        {isAuthenticated && id_user !== authUser?.id ? (
            <li>
                <ul className="ul-normal">
                    <span className="dropdown-item cursor-pointer user-select-none" onClick={handleBlockUser}>
                        <div className="div-icon-fix">
                            {!isBlocked ? (
                                <><UserX data-feather="paperclip" data-type="unfix" className="icon-config-post"/>{t("post.actions.blockUser")} </>
                            ) : (
                                <><UserCheck data-feather="paperclip" data-type="fix" className="icon-config-post"/>{t("post.actions.unblockUser")} </>
                            )}
                        </div>
                    </span>
                </ul>
            </li>
        ) : null}
        
        </>
    );
};

export default BlockUser;
